module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [(_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-mobile-back",
    on: {
      "click": function($event) {
        return _vm.$root.mobileBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.album) ? _c('div', {
    staticClass: "pp-album-view"
  }, [(_vm.$root.view != 'mobile') ? _c('div', {
    staticClass: "pp-album-view__sidebar"
  }, [_c('div', {
    staticClass: "pp-album-view__artwork"
  }, [_c('img', {
    attrs: {
      "src": _vm.album.artwork
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__summary",
    domProps: {
      "innerHTML": _vm._s(_vm.album.summary)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__tabs"
  }, [_c('div', {
    staticClass: "pp-album-view__tabs__headers"
  }, _vm._l((_vm.album.tabs), function(tab) {
    return _c('div', {
      class: {
        'pp-album-view__tabs__headers__header': 1,
        'pp-album-view__tabs__headers__header--active': tab.active
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(tab.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tab.label) + "\n                    ")])
  }), 0), _vm._v(" "), _vm._l((_vm.album.tabs), function(tab) {
    return (tab.active) ? _c('div', {
      staticClass: "pp-album-view__tabs__content",
      domProps: {
        "innerHTML": _vm._s(tab.content)
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-album-view__mobile-header"
  }, [_c('div', {
    staticClass: "pp-album-view__mobile-slider"
  }, [_c('swiper', {
    ref: "albumSlider",
    attrs: {
      "options": _vm.sliderOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "pp-album-view__artwork"
  }, [_c('img', {
    attrs: {
      "src": _vm.album.artwork
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.album.title) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__artist"
  })]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "pp-album-view__summary",
    domProps: {
      "innerHTML": _vm._s(_vm.album.summary)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__main"
  }, [(_vm.$root.view != 'mobile') ? _c('div', {
    staticClass: "pp-album-view__title"
  }, [_vm._v("\n                " + _vm._s(_vm.album.title) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__actions"
  }, [_c('div', {
    staticClass: "pp-album-view__action",
    on: {
      "click": _vm.playAlbum
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-play"
  }), _vm._v(" Play album\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-album-view__action",
    on: {
      "click": _vm.queueAlbum
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-indent"
  }), _vm._v(" Add tracks to queue\n                ")])]), _vm._v(" "), _c('track-list', {
    attrs: {
      "items": _vm.album.tracks
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a9b9cac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/ViewAlbum.vue
// module id = 120
// module chunks = 0 1